import React, { FC } from 'react';
import { useRoute } from '@react-navigation/native';

import DashboardDrilldownWrapper from './components/DashboardDrilldownWrapper';
import DashboardDrilldownNcFileBody from './components/DashboardDrilldownNcFileBody';
import { DashboardDrilldownScope, type DashboardDrilldownNcFileRouteParams } from '@v2/pages/dashboard/common/types/drilldown';

const DashboardDrilldownNcFileScreen: FC = () => {
  const route = useRoute<any>();
  const params = (route.params ?? {}) as Partial<DashboardDrilldownNcFileRouteParams>;
  const ncFileIdRaw = params.ncFileId;

  if (!ncFileIdRaw) return null;
  const ncFileId = Number(ncFileIdRaw);
  if (!Number.isFinite(ncFileId)) return null;

  return (
    <DashboardDrilldownWrapper scope={DashboardDrilldownScope.NcFile} entityName={params.ncFileName}>
      <DashboardDrilldownNcFileBody ncFileId={ncFileId} />
    </DashboardDrilldownWrapper>
  );
};

export default DashboardDrilldownNcFileScreen;
